import { signUpUrl } from '../../../Container/App'
import Index from '../../../Assets/Images/Index'
import CountUpOnView from './Counter'
import Fade from 'react-reveal/Fade';

export default function Sell() {
    return (
        <main>
            <section className="banner commonPY" style={{ backgroundImage: `url(${Index.headerbanner2New})` }}>
                <div className="container z-index">
                    <div className="row">
                        <Fade up>
                            <div className="col-md-5">
                                <div className="bannerContent">
                                    <h1>All-in-one Ecommerce Platform</h1>
                                    <p>We aim to offer you the best-fit services tailored to your needs. Hurry Up!</p>
                                    <div className="buttonOuter">
                                        <a className="commonButton primary" href={signUpUrl}>Get Free Trial</a>
                                    </div>
                                </div>
                            </div>
                        </Fade>
                    </div>
                </div>
            </section>

            <section className="globally commonPY">
                <div className="container">
                    <Fade up>
                        <div className="headingText left mb-5">
                            <h2>Sell Across the Nation <br />with <span>Confidence</span></h2>
                            <p>Powering thousands of businesses across India with seamless eCommerce solutions.</p>
                        </div>
                    </Fade>
                    <div className="businessesNation">
                        <div className="row align-items-center">
                            <Fade up>
                                <div className="col-lg-6 order-lg-1">
                                    <div className="globeImage"><img src={Index.globeImg} alt="" /></div>
                                </div>
                            </Fade>
                            <div className="col-lg-6">
                                <div className="row">
                                    <Fade up>
                                        <div className="col-sm-6">
                                            <div className="businessesCard">
                                                <div className="counter"><CountUpOnView target={4} /></div>
                                                <h5>Payment Gateways</h5>
                                            </div>
                                        </div>
                                    </Fade>
                                    <Fade up>
                                        <div className="col-sm-6">
                                            <div className="businessesCard">
                                                <div className="counter"><CountUpOnView target={1100} />+</div>
                                                <h5>Merchants on Shopyxa</h5>
                                            </div>
                                        </div>
                                    </Fade>
                                    <Fade up>
                                        <div className="col-sm-6">
                                            <div className="businessesCard">
                                                <div className="counter"><CountUpOnView target={150} />+</div>
                                                <h5>Cities Covered</h5>
                                            </div>
                                        </div>
                                    </Fade>
                                    <Fade up>
                                        <div className="col-sm-6">
                                            <div className="businessesCard">
                                                <div className="counter">₹<CountUpOnView target={1.3} duration={8000} />M</div>
                                                <h5>Economic Activity</h5>
                                            </div>
                                        </div>
                                    </Fade>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className="contentBlock commonPY">
                <div className="container">
                    <div className="contentBlockInner">
                        <div className="row">
                            <Fade up>
                                <div className="col-lg-6 parallax delay-2">
                                    <div className="contentBlockImage">
                                        <img src={Index.sellcontentBlock1} alt="" />
                                    </div>
                                </div>
                            </Fade>
                            <Fade up>
                                <div className="col-lg-6 parallax delay-4">
                                    <div className="contentBlockContent">
                                        <h3>Cutting-edge eCommerce Platform</h3>
                                        <p>Experience all e-commerce solutions under one roof with Shopyxa. Sell your products and
                                            services on customized Shopyxa stores. Grow your revenue with fast-loading and optimized
                                            online stores.</p>
                                        <div className="buttonOuter mt-0">
                                            <a className="commonButton primary" href={signUpUrl}>Start Free Trial</a>
                                        </div>
                                    </div>
                                </div>
                            </Fade>
                        </div>
                    </div>
                    <div className="contentBlockInner">
                        <div className="row">
                            <Fade up>
                                <div className="col-lg-6 parallax delay-2">
                                    <div className="contentBlockImage">
                                        <img src={Index.sellcontentBlock2} alt="" />
                                    </div>
                                </div>
                            </Fade>
                            <Fade up>
                                <div className="col-lg-6 parallax delay-4">
                                    <div className="contentBlockContent">
                                        <h3>Sell With No Worries</h3>
                                        <p>Are you selling products online from home? Want your products in the spotlight? The
                                            answer is the Shopyxa store, where you can leverage the advantages of extended features
                                            and functionalities to reach a wider audience.</p>
                                        <div className="buttonOuter mt-0">
                                            <a className="commonButton primary" href={signUpUrl}>Start Free Trial</a>
                                        </div>
                                    </div>
                                </div>
                            </Fade>
                        </div>
                    </div>
                    <div className="contentBlockInner">
                        <div className="row">
                            <Fade up>
                                <div className="col-lg-6 parallax delay-2">
                                    <div className="contentBlockImage">
                                        <img src={Index.sellcontentBlock3} alt="" />
                                    </div>
                                </div>
                            </Fade>
                            <Fade up>
                                <div className="col-lg-6 parallax delay-4">
                                    <div className="contentBlockContent">
                                        <h3>Launch Optimized Store</h3>
                                        <p>Theme layouts follow effective ideas to catch visitors' eyes. You can spice up your store
                                            with optimized titles, descriptions, and high-quality pictures. Hundreds of
                                            entrepreneurs trusted Shopyxa, an all-in-one e-commerce platform, to build a strong
                                            digital presence.</p>
                                        <div className="buttonOuter mt-0">
                                            <a className="commonButton primary" href={signUpUrl}>Start Free Trial</a>
                                        </div>
                                    </div>
                                </div>
                            </Fade>
                        </div>
                    </div>
                </div>
            </section>

            <section className="cta commonPB">
                <div className="container">
                    <Fade up>
                        <div className="ctaInner">
                            <div className="headingText white parallax delay-1">
                                <h5>Your online store is just a few clicks away!</h5>
                                <h2>Start with 15 days Free Trial</h2>
                            </div>
                            <div className="buttonOuter parallax delay-3">
                                <a className="commonButton outline" href={signUpUrl}>Get Started</a>
                            </div>
                        </div>
                    </Fade>
                </div>
            </section>


        </main>
    )
}
